module.exports = __webpack_public_path__ + "img/image-1.3fa56cbe.png";